import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import SEO from '../components/SEO';
import AnimatedSection from '../components/AnimatedSection';
import PageHeader from '../components/PageHeader';
import VisiMisi from '../components/VisiMisi';

const VisiMisiPage = () => {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, 'pageContent', 'tentangKami');
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setPageData(docSnap.data());
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <SEO
                title="Visi dan Misi - SMK Pariwisata Sumbangsih"
                description="Visi dan Misi SMK Pariwisata Sumbangsih dalam mencetak generasi unggul."
            />
            <PageHeader
                title="Visi dan Misi"
                subtitle="Arah dan Tujuan Kami"
            />
            {loading ? (
                <section className="section">
                    <div className="container" style={{ textAlign: 'center' }}>Memuat konten...</div>
                </section>
            ) : (
                <AnimatedSection>
                    <VisiMisi visi={pageData?.visi} misi={pageData?.misi} />
                </AnimatedSection>
            )}
        </>
    );
};

export default VisiMisiPage;
